import { AppDatePickerProps, AppFormItem } from 'components/atoms';
import { StyledDatePicker } from 'components/molecules/FormElements/DatePickerElement/DatePickerElement';
import { DATE_LABEL, OPTIONAL_FIELD_LABEL } from 'consts/labels/common';

type SimpleDatePickerProps = Omit<AppDatePickerProps, 'onReset'> & {
    formItemLabel: string;
    optional?: boolean;
    isHalfParentWidth?: boolean;
    name: string;
    hideDateLabel?: boolean;
};

export const SimpleDatePicker = ({
    formItemLabel,
    onChange,
    name,
    optional = false,
    isHalfParentWidth = false,
    hideDateLabel = false,
    disabledDate,
    disabled,
    placeholder,
    ...restProps
}: SimpleDatePickerProps) => {
    let additionalText = '';

    if (!hideDateLabel) {
        additionalText = DATE_LABEL;
    }

    if (optional) {
        additionalText = additionalText
            ? `${additionalText} - ${OPTIONAL_FIELD_LABEL}`
            : OPTIONAL_FIELD_LABEL;
    }
    return (
        <AppFormItem
            name={name}
            label={<AppFormItem.Label mainText={formItemLabel} additionalText={additionalText} />}
            optional={optional}
            {...restProps}
        >
            <StyledDatePicker
                autoComplete="off"
                isHalfParentWidth={isHalfParentWidth}
                disabledDate={disabledDate}
                disabled={disabled}
                onChange={onChange}
                placeholder={placeholder}
            />
        </AppFormItem>
    );
};
